import { AppFormTabProps } from "components/AppFormLayout/AppFormData";

export const ParamTabsData = [
	{
		tabId: 0,
		title: '',
        isHidden: false,
		appFormBlockList: [
			{
				colNumber: 1,
				title: '',
				labelWidth: 100,
				appFormItemList: [
					{
						type: 'Input',
						defaultValue: '',
						field: 'showName',
						label: '参数名',
						placeholder:"请输入参数名"
					},
					{
						type: 'Input',
						defaultValue: '',
						field: 'keyName',
						label: '唯一标识',
						placeholder:"请输入唯一标识,建议系统编码_标识，例如00_test",
						req: true,
                    },
                    {
						type: 'Select',
						defaultValue: '',
						field: 'paramType',
						label: '参数类型',
						req: true,
						placeholder:"请输入参数类型",
						appFormItemOptionList:[{value:0,label:"列表参数"},{value:1,label:"树形列表"},{value:2,label:"自定义"}]
                    },
                    {
						type: 'Input',
						defaultValue: '',
						field: 'sort',
						label: '排序Code',
						placeholder:"请输入排序编码，建议与唯一标识保持一致,如:00_test1",
						req: true,
					},
					{
						type: 'Input',
						defaultValue: '',
						field: 'pageUrl',
						label: '自定义',
						placeholder:"请配置自定义页签,例如:/test",
						req: true,
					},
					{
						type: 'Input',
						defaultValue: '',
						field: 'actionCode',
						label: '权限Code',
						req: true,
						placeholder:"请输入2位编码,例如：01",
					},
					{
						type: 'Input',
						defaultValue: '',
						field: 'describe',
						label: '描述',
						placeholder:"请输入参数描述",
					},
                   
				],
			},
			// {
			// 	colNumber:1,
			// 	title:'',
			// 	labelWidth:100,
			// 	appFormItemList:[
			// 			{
			// 				type: 'Textarea',
			// 				defaultValue: '',
			// 				field: 'describe',
			// 				label: '描述',
			// 			},
					
			// 	]
			// }
		],
		
	}
] as AppFormTabProps[]


// WEBPACK FOOTER //
// ./src/modules/modeling/param/components/ParamEditData.tsx